import { getImageUrl } from '$lib/utils';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';
import type { Article, WithContext } from 'schema-dts';
import { getArticleDates } from '../utils';
import type { PageLoad } from './$types';

dayjs.extend(utc);
dayjs.extend(timezone);

export const load: PageLoad = async ({ data, url }) => {
	const { dateModified } = getArticleDates(data.article.createdAt, data.article.publishedAt);
	const schema: WithContext<Article> = {
		'@context': 'https://schema.org',
		'@type': 'Article',
		mainEntityOfPage: { '@type': 'WebPage', '@id': url.toString() },
		name: data.article.title,
		description: data.article.description,
		image: getImageUrl(data.article.cover),
		headline: data.article.title,
		dateModified: dayjs.utc(dateModified).tz('Asia/Singapore').toISOString(),
		datePublished: dayjs.utc(dateModified).tz('Asia/Singapore').toISOString(),
		publisher: {
			'@type': 'Organization',
			name: 'Beansprout',
			logo: {
				'@type': 'ImageObject',
				url: `${url.origin}/favicon.png`
			}
		}
	};
	return {
		...data,
		title: data.article.title,
		description: data.article.description,
		opengraph: {
			title: data.article.title,
			type: 'article',
			image: getImageUrl(data.article.cover),
			url: url.href
		},
		schemas: [schema],
		pageContext: `${data.article.category.uid}${
			data.article.themes.length ? ` - ${data.article.themes[0]?.uid}` : ''
		}`
	};
};
